import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Is a match guaranteed if I attend?",
    a: "No. Cita Rush curates the event experience — the venue, hosts, games, and mini-dates. Matches depend on mutual chemistry. We ensure quality attendees and a structured, comfortable setting, but we cannot guarantee specific outcomes.",
  },
  {
    q: "What if I don't get any matches?",
    a: "If you attend an event and receive zero mutual matches, we'll send you a one-time discount code toward a future event. There are no cash refunds, but we want you to try again with confidence.",
  },
  {
    q: "How do you keep it safe for women?",
    a: "Women attend free but go through a waitlist verification. All guests must be 18+ with valid ID. Events are held at partner venues with security. We enforce a strict code of conduct — any violation leads to a permanent ban.",
  },
  {
    q: "When do I get my matches?",
    a: "After the event, you'll submit your yes/maybe/no preferences through a private form. Within 24-48 hours, you'll receive the contact details of your mutual matches only (where both people said yes or maybe).",
  },
  {
    q: "Can I get someone's contact if they didn't choose me?",
    a: "No. Privacy is central to Cita Rush. Contact details are shared strictly on mutual consent. This ensures everyone feels safe and respected.",
  },
  {
    q: "How can venues partner with Cita Rush?",
    a: "If you run a cafe, restaurant, bar, or event space in Pune, we'd love to talk. Click 'Partner with us' or email us. We bring curated foot traffic, professional hosting, and brand-safe events to your space.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      className="py-24 sm:py-32"
      data-testid="faq-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="grid lg:grid-cols-5 gap-12 lg:gap-20">
          {/* Left label */}
          <motion.div
            className="lg:col-span-2"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
          >
            <p className="font-mono text-xs tracking-[0.2em] uppercase font-semibold text-[hsl(var(--accent))] mb-4">
              Questions
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight font-medium mb-4">
              Frequently asked
            </h2>
            <p className="text-base leading-relaxed text-muted-foreground">
              Everything you need to know about Cita Rush events, safety, and matching.
            </p>
          </motion.div>

          {/* Right: Accordion */}
          <motion.div
            className="lg:col-span-3"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-border/60"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="text-left text-base font-medium hover:no-underline py-5" data-testid={`faq-trigger-${i}`}>
                    {faq.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-base leading-relaxed text-muted-foreground" data-testid={`faq-content-${i}`}>
                    {faq.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
